import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const defaultRender = (value) => (value ? value : "");

const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const formattedDate = date.toISOString().slice(0, 19);
    const milliseconds = date.getMilliseconds();
    const formattedMilliseconds = (milliseconds / 1000).toFixed(2).slice(2);
    return `${formattedDate}.${formattedMilliseconds}`;
};
const formatPrice = (value, decimalPlaces) => {
    if (value === null || value === undefined) return "";
    return Number(value)?.toFixed(decimalPlaces);
};

const useOrderCell = () => {
    const { t } = useTranslation();
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);


    return [
        { title: t("time"), dataIndex: 'dateTime', render: defaultRender, },
        { title: t("id"), dataIndex: 'ticket', render: defaultRender, },
        { title: t('openTicket'), dataIndex: 'openTicket', render: defaultRender, },
        { title: t('symbol'), dataIndex: 'symbolName', render: defaultRender, },
        { title: t('openPrice'), dataIndex: 'openPrice', render:  (value) => formatPrice(value, decimalPlaces), },
        { title: t('amount'), dataIndex: 'amount', render: defaultRender, },
        { title: t('s/l'), dataIndex: 'stopLoss', render: defaultRender, },
        { title: t('t/p'), dataIndex: 'takeProfit', render: defaultRender, },
        { title: t("comment"), dataIndex: "comment", render: defaultRender },];
};

export default useOrderCell;
